export default "__VITE_ASSET__ClIWsmSZ__"